/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LimitsParams,
  SchemaValidationErrorResponse,
  UserLimit,
  UserLimits
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Users Limits
 */
export const limits = (
    params: MaybeRefOrGetter<LimitsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<UserLimit>(
      {url: `/user_limits`, method: 'GET',
        params, signal
    },
      );
    }




export const getLimitsQueryKey = (params?: MaybeRefOrGetter<LimitsParams>,) => {
    return [
    'user_limits', ...(params ? [params] : [])
    ] as const;
    }


export const getLimitsQueryOptions = <TData = Awaited<ReturnType<typeof limits>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params: MaybeRefOrGetter<LimitsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof limits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLimitsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof limits>>> = ({ signal }) => limits(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof limits>>, TError, TData>
}

export type LimitsQueryResult = NonNullable<Awaited<ReturnType<typeof limits>>>
export type LimitsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Users Limits
 */

export function useLimits<TData = Awaited<ReturnType<typeof limits>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params: MaybeRefOrGetter<LimitsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof limits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLimitsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary All User Limits
 */
export const allLimits = (

 signal?: AbortSignal
) => {


      return axiosClient<UserLimits>(
      {url: `/user_limits/all`, method: 'GET', signal
    },
      );
    }




export const getAllLimitsQueryKey = () => {
    return [
    'user_limits','all'
    ] as const;
    }


export const getAllLimitsQueryOptions = <TData = Awaited<ReturnType<typeof allLimits>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allLimits>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAllLimitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof allLimits>>> = ({ signal }) => allLimits(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allLimits>>, TError, TData>
}

export type AllLimitsQueryResult = NonNullable<Awaited<ReturnType<typeof allLimits>>>
export type AllLimitsQueryError = ErrorType<void>


/**
 * @summary All User Limits
 */

export function useAllLimits<TData = Awaited<ReturnType<typeof allLimits>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allLimits>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAllLimitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






